// Render join form
import React, { useState, useEffect } from "react";
import { useApi } from "../../hooks/UseApi";
import BillingAddressFields from "./BillingAddressFields";
import Button from "./Button";
import EmailAddressField from "./EmailAddressField";
import FormActions from "./FormActions";
import FormErrors from "./FormErrors";
import { levels, defaultLevel } from "./Levels";
import LevelSelector from "./LevelSelector";
import Loader from "./Loader";
import MailingAddressFields from "./MailingAddressFields";
import PaymentMethodFields from "./PaymentMethodFields";
import PrivacyPolicy from "./PrivacyPolicy";
import ProfileFields from "./ProfileFields";

const Join = (props) => {
  const { get } = useApi();
  const [nextNumber, setNextNumber] = useState("");
  useEffect(() => {
    get("membership/next").then((data) => {
      if (data) {
        if (!isNaN(data.membership_number)) {
          setNextNumber(data.membership_number.toLocaleString("en-US"));
        }
      }
    });
  }, []);
  return (
    <div className="component-join">
      <div className="intro">
        <div className="intro-card">
          <div className="membership-card">
            <div className="membership-card-number">{nextNumber}</div>
          </div>
        </div>
        <div className="intro-text">
          <p>
            Long Now membership connects you to a whole world of long-term
            thinking.
          </p>
          <p>
            Together, our monthly members provide more than one-third of our
            overall support.
          </p>
          <h3>Choose a membership level —</h3>
        </div>
      </div>
      <LevelSelector levels={levels} initialLevel={defaultLevel}>
        <PaymentMethodFields />
        <EmailAddressField />
        <BillingAddressFields />
        <MailingAddressFields sameAsBillingOption="true" />
        <ProfileFields />
        <PrivacyPolicy />
        {props.formError && <FormErrors message={props.formError} />}
        <FormActions>
          <Button action="join" ref={props.submit} />
          <Loader ref={props.loader} />
        </FormActions>
      </LevelSelector>
    </div>
  );
};
export default Join;
